// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import App from './App';
// 引入路由
import router from './router';
import directive from './directive' // directive
// 引入权限控制
import './permission' // permission control
// 引入状态管理
// import store from './vuex/store';
import store from './store';
// 引入icon
import './assets/icon/iconfont.css'

import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)
// 引入 echarts
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

Vue.use(directive)


//tree
import '@/assets/styles/ruoyi.css'
import {handleTree,resetForm} from "@/utils/ruoyi";
Vue.prototype.handleTree = handleTree
Vue.prototype.resetForm = resetForm

// 菜单权限
import {checkPermission} from "@/utils/hasPermission";
Vue.prototype.checkPermission = checkPermission

// 消息提示方法
Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'success' })
}
Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'error' })
}
Vue.prototype.$message = function (options) {
  return this.$message(options)
}


// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'
//地图
/*import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'hvos0GWN0zhbHGSHWAUwcnQIT6OwVeW8'
})*//*
import {
  BmlMarkerClusterer
} from 'vue-baidu-map'
Vue.component('bml-marker-cluster', BmlMarkerClusterer)*/
Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})



// WEBPACK FOOTER //
// ./src/main.js